export const ROADMAP_DATA = [
  {
    step: "Step 1",
    title: "첫 장비의 설렘",
    subtitle: "기본이자 가장 중요한 아이템",
    description: "렌탈 장비에서 벗어나 내 얼굴에 꼭 맞는 기본 장비를 준비할 때입니다. 물속에서 사진이 가장 많이 찍히는 부분이므로 디자인도 매우 중요하죠.",
    items: [
      { 
        id: 'mask', 
        name: "마스크", 
        type: "basic", 
        desc: "프리다이빙에서는 내부 용적(공기 용량)이 적은 마스크가 유리합니다. 또한 편안한 이퀄라이징을 위해 코 부분이 부드러운 실리콘 재질로 된 것을 고르는 것이 가장 중요합니다.",
        products: [
          {
            badge: "유리 마스크",
            badgeColor: "#475569",
            name: "아폴로 바이오 메탈 마스크 타입D",
            image: "https://www.pongdang.com/data/goods/61/2025/10/42172_temp_17593812415123view.png",
            link: "https://www.pongdang.com/goods/view?no=42172"
          },
          {
            badge: "플라스틱 마스크",
            badgeColor: "#334155",
            name: "브랑키아 딥아이 Z",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260713/9797c24769739cea2f2dda869d8446c5.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%ED%94%84%EB%A6%AC%EB%8B%A4%EC%9D%B4%EB%B9%99-%EB%A7%88%EC%8A%A4%ED%81%AC-%EB%94%A5%EC%95%84%EC%9D%B4-z/360/category/24/display/3/"
          },
          {
            badge: "플라스틱 마스크",
            badgeColor: "#334155",
            name: "더블케이 재규어R 마스크",
            image: "https://divingkk.com/web/product/big/202402/254459425ee152e58bda62fa8a56d522.png",
            link: "https://divingkk.com/product/detail.html?product_no=2500&cate_no=278&display_group=1"
          }
        ]
      },
      { 
        id: 'snorkel', 
        name: "스노클", 
        type: "basic", 
        desc: "스쿠버용과 달리 물 배출 밸브(퍼지 밸브)가 없는 심플한 형태가 좋습니다. 물의 저항을 줄이기 위해 가볍고 너무 말랑거리지 않는 재질을 추천합니다. 특히 '양성부력' 기능이 있으면 실수로 떨어뜨려도 물에 가라앉지 않고 수면에 떠서 분실 위험이 없습니다.",
        products: [
          {
            badge: "양성부력",
            badgeColor: "#0284c7",
            name: "브랑키아 딥브레스 양성부력 스노클",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260612/8eb02e509c96cc71820b3937bceb0963.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EB%94%A5%EB%B8%8C%EB%A0%88%EC%8A%A4-%EC%96%91%EC%84%B1%EB%B6%80%EB%A0%A5-%EC%8A%A4%EB%85%B8%ED%81%B4/364/category/24/display/1/"
          }
        ]
      },
      { 
        id: 'antifog', 
        name: "안티포그", 
        type: "basic", 
        desc: "시야가 흐려지면 멋진 다이빙 폼도 소용없죠. 항상 맑고 깨끗한 수중 시야를 유지하기 위한 든든한 필수품입니다.",
        products: [
          {
            badge: "드롭형",
            badgeColor: "#64748b",
            name: "브랑키아 안티포그 원드롭",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260701/154ecb8248bea4d070d9161d87b3cc81.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EC%95%88%ED%8B%B0%ED%8F%AC%EA%B7%B8-%EC%9B%90%EB%93%9C%EB%A1%AD-%EC%88%98%EC%98%81-%EC%8A%A4%EB%85%B8%ED%81%B4%EB%A7%81-%ED%94%84%EB%A6%AC%EB%8B%A4%EC%9D%B4%EB%B9%99-%EC%8A%A4%EC%BF%A0%EB%B2%84%EB%8B%A4%EC%9D%B4%EB%B9%99/358/category/24/display/1/"
          },
          {
            badge: "스프레이형",
            badgeColor: "#64748b",
            name: "오션테그 대용량 Wiper G 100ml",
            image: "https://www.pongdang.com/data/goods/247/2025/06/51617_temp_17497959730128view.png",
            link: "https://www.pongdang.com/goods/view?no=51617"
          }
        ]
      }
    ]
  },
  {
    step: "Step 2",
    title: "물속을 가르는 우아함",
    subtitle: "다이빙의 꽃, 롱핀",
    description: "진정한 프리다이버의 실루엣은 '롱핀'에서 완성됩니다. 수중 저항을 최소화하고 부드럽고 강력한 추진력으로 깊은 수심을 가르는 짜릿함을 경험해보세요.",
    isFins: true,
    items: [

      { 
        id: 'fin_socks', 
        name: "핀삭스", 
        type: "basic", 
        desc: "뒤꿈치 까짐 방지 및 체온 유지용 숨은 조력자입니다. 핀 사이즈가 약간 크거나 딱 맞는 사이즈가 없을 때, 삭스의 두께(1~3mm)를 조절하여 빈틈없는 피팅을 완성할 수 있습니다.",
        products: [
          {
            badge: "2.5mm",
            badgeColor: "#64748b",
            name: "브랑키아 2.5mm 롱삭스",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/shop1_591d2743f292e297d6d8f42bf3e62ba8.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-25mm-%EB%A1%B1%EC%82%AD%EC%8A%A4/37/category/26/display/1/"
          },
          {
            badge: "0.5mm 스타킹",
            badgeColor: "#64748b",
            name: "브랑키아 아쿠아모션 0.5mm 핀스타킹",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20251126/31f1f076072872bc42596ea8c1c6b266.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EC%95%84%EC%BF%A0%EC%95%84%EB%AA%A8%EC%85%98-05mm-%ED%95%80%EC%8A%A4%ED%83%80%ED%82%B9-%ED%94%84%EB%A6%AC%EB%8B%A4%EC%9D%B4%EB%B9%99-%EC%82%AD%EC%8A%A4-%EB%8B%A4%EC%9D%B4%EB%B9%99-%EC%8A%A4%ED%83%80%ED%82%B9-%EB%82%B1%EA%B0%9C/367/category/26/display/1/"
          }
        ]
      },
      { 
        id: 'fin_bag', 
        name: "롱핀 가방", 
        type: "basic", 
        desc: "고가의 롱핀을 안전하게 보호할 뿐만 아니라, 마스크, 스노클, 웨이트 등 자잘한 장비까지 한 번에 수납하여 다이빙 풀로 향하는 발걸음을 가볍고 스타일리시하게 만들어줍니다.",
        products: [
          {
            badge: "백팩형",
            badgeColor: "#475569",
            name: "브랑키아 블랙코어 50L 롱핀 백팩",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20251214/ad8a8c8e5ddcf0445b08c645ea94a221.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EB%B8%94%EB%9E%99%EC%BD%94%EC%96%B4-50l-%EB%A1%B1%ED%95%80-%EB%B0%B1%ED%8C%A9/87/category/48/display/3/"
          },
          {
            badge: "하드케이스",
            badgeColor: "#475569",
            name: "알케미 하드폼 롱백2",
            image: "https://freedivingstore.co.kr/web/product/big/202402/1f2bc8b96a95c3ac0fe6f3f52c110bd9.jpg",
            link: "https://freedivingstore.co.kr/product/detail.html?product_no=2384&cate_no=53&display_group=1"
          },
          {
            badge: "슬리브",
            badgeColor: "#475569",
            name: "브랑키아 롱핀 슬리브",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260706/5936738a214d153c7ab248b080b0466e.png",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EB%A1%B1%ED%95%80-%EC%8A%AC%EB%A6%AC%EB%B8%8C/32/category/48/display/1/"
          },
          {
            badge: "백팩형",
            badgeColor: "#475569",
            name: "이스케이프 롱핀가방",
            image: "https://deeplyfin.com/web/product/big/202607/7e40809774375aac3f5aa88c9b22f134.jpg",
            link: "https://deeplyfin.com/product/%EC%9D%B4%EC%8A%A4%EC%BC%80%EC%9D%B4%ED%94%84-%EB%A1%B1%ED%95%80%EA%B0%80%EB%B0%A9/361/category/202/display/1/"
          }
        ]
      }
    ]
  },
  {
    step: "Step 3",
    title: "제 2의 피부",
    subtitle: "체온 보호와 스타일의 완성, 프리다이빙 슈트",
    description: "물속에서 오래 머물기 위해서는 체온 유지가 필수입니다. 투피스 형태의 전용 슈트는 활동성이 좋고 다이버의 핏을 아름답게 살려줍니다. 특히 슈트는 내 몸에 꼭 맞게 입는 것이 매우 중요합니다. 품이 남아 헐렁할 경우 차가운 물이 계속 유입되어 체온을 빠르게 빼앗아가므로, 빈틈없이 밀착되는 핏과 목적에 맞는 두께를 선택하세요.",
    isWetsuit: true,
    items: [
      { 
        id: 'gloves', 
        name: "바다용 다이빙 장갑 (3mm)", 
        type: "basic", 
        desc: "해양 다이빙 시 해파리나 날카로운 바위로부터 손을 안전하게 보호하고 체온 손실을 막아주는 바다 필수템입니다.",
        products: [
          {
            badge: "3mm",
            badgeColor: "#64748b",
            name: "마레스 플렉사 클래식 3mm 장갑",
            image: "https://www.pongdang.com/data/goods/1/2025/06/53769_temp_17497928572219view.jpg",
            link: "https://www.pongdang.com/goods/view?no=53769"
          }
        ]
      },
      { 
        id: 'ocean_socks', 
        name: "바다용 핀삭스 (2.5~3mm)", 
        type: "basic", 
        desc: "차가운 바다 수온으로부터 발을 보호하는 두께감 있는 핀삭스. 슈트, 장갑과 함께 세트로 꼭 챙겨야 합니다.",
        products: [
          {
            badge: "2.5mm",
            badgeColor: "#64748b",
            name: "크레시 메탈라이트 2.5mm",
            image: "https://www.pongdang.com/data/goods/70/2025/02/33025_temp_17398567475187view.jpg",
            link: "https://www.pongdang.com/goods/view?no=33025"
          }
        ]
      },
      { 
        id: 'hats', 
        name: "다이빙 모자", 
        type: "basic", 
        desc: "뜨거운 태양으로부터 피부를 보호하고, 헝클어진 머리를 정돈해주는 바다 다이빙의 필수 스타일링 아이템입니다.",
        products: [
          {
            badge: "테크/버킷/부니햇",
            badgeColor: "#64748b",
            name: "브랑키아 다이버 테크햇",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260617/a5cbdb7dc404d07e0f22eb90fd2b52f6.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EB%8B%A4%EC%9D%B4%EB%B2%84-%ED%85%8C%ED%81%AC%ED%96%87-%EB%B2%84%ED%82%B7%ED%96%87-%EB%B6%80%EB%8B%88%ED%96%87/26/category/48/display/1/"
          },
          {
            badge: "테크캡",
            badgeColor: "#64748b",
            name: "브랑키아 다이버 테크캡",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260512/29d26132feda4ab9424ebe8bf3a52d93.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%EB%8B%A4%EC%9D%B4%EB%B2%84-%ED%85%8C%ED%81%AC%EC%BA%A1/31/category/48/display/1/"
          },
          {
            badge: "정글모",
            badgeColor: "#64748b",
            name: "PADI 정글모",
            image: "https://www.pongdang.com/data/goods/77/2024/06/42606_temp_17173879989825view.jpg",
            link: "https://www.pongdang.com/goods/view?no=42606"
          },
          {
            badge: "버킷햇",
            badgeColor: "#64748b",
            name: "산티 버킷햇",
            image: "https://www.pongdang.com/data/goods/48/2023/01/41204_temp_16751259680507view.jpg",
            link: "https://www.pongdang.com/goods/view?no=41204"
          }
        ]
      }
    ]
  },
  {
    step: "Step 4",
    title: "완벽한 중성부력",
    subtitle: "떠있지도, 가라앉지도 않는 편안함",
    description: "슈트를 입어 증가한 부력을 상쇄하기 위한 웨이트 장비입니다. 고수들의 여유로운 유영은 완벽한 웨이트 세팅에서 나옵니다.",
    items: [
      { 
        id: 'neck_weight', 
        name: "넥웨이트", 
        type: "basic", 
        desc: "부력의 큰 부분을 차지하는 폐 때문에 뜨기 쉬운 상체를 눌러주어 정확한 수평 자세를 만들 수 있게 해주는 핵심 장비입니다. 견고하게 만들어진 인체공학적 디자인의 넥웨이트를 추천합니다.",
        products: [
          {
            badge: "일체형",
            badgeColor: "#64748b",
            name: "브랑키아 프리다이빙 넥웨이트",
            image: "https://ecimg.cafe24img.com/pg1525b19552753055/branciiia/web/product/big/20260504/41fddd88ff8c01b163a14c2a3cf51271.jpg",
            link: "https://www.branciiia.co.kr/product/%EB%B8%8C%EB%9E%91%ED%82%A4%EC%95%84-%ED%94%84%EB%A6%AC%EB%8B%A4%EC%9D%B4%EB%B9%99-%EB%84%A5%EC%9B%A8%EC%9D%B4%ED%8A%B8/365/category/23/display/1/"
          }
        ]
      },
      { 
        id: 'belt', 
        name: "웨이트/벨트", 
        type: "basic", 
        desc: "실리콘 소재로 허리에 착 감겨 다이빙 중에도 돌아가지 않는 벨트와, 미세한 부력 조절을 위해 여러 개 분산 착용하기 좋은 가벼운 0.5kg 코팅 납 웨이트를 추천합니다.",
        products: [
          {
            badge: "실리콘벨트",
            badgeColor: "#64748b",
            name: "더블케이 실리콘벨트",
            image: "https://divingkk.com/web/product/big/202404/3e4eca38dd20ed9d2290b963d461516d.png",
            link: "https://divingkk.com/product/detail.html?product_no=2543&cate_no=728&display_group=1"
          },
          {
            badge: "납 웨이트",
            badgeColor: "#64748b",
            name: "더블케이 코팅 납 웨이트",
            image: "https://divingkk.com/web/product/big/202210/c36c7a5120aa92fd0a87a5fc876fa876.jpg",
            link: "https://divingkk.com/product/detail.html?product_no=2539&cate_no=351&display_group=1"
          }
        ]
      },
      { 
        id: 'lobster', 
        name: "랍스터 넥웨이트", 
        type: "advanced", 
        desc: "인도어(수영장) 트레이닝을 위한 끝판왕 가변형 넥웨이트. 블록을 자유롭게 뗐다 붙일 수 있어, 부력 변화가 큰 얕은 수심(다이빙 풀장)에서도 나에게 맞는 완벽한 중성부력을 세팅할 수 있는 고수들의 필수템입니다.",
        products: [
          {
            badge: "가변형",
            badgeColor: "#ef4444",
            name: "랍스터 넥 웨이트 세트",
            image: "https://www.pongdang.com/data/goods/1/2023/03/51952_2023033013450917.jpg",
            link: "https://www.pongdang.com/goods/view?no=51952"
          },
          {
            badge: "다이노",
            badgeColor: "#ef4444",
            name: "C4 다이노 넥웨이트",
            image: "https://www.pongdang.com/data/goods/310/2026/06/61189_temp_17814977416996view.png",
            link: "https://www.pongdang.com/goods/view?no=61189"
          }
        ]
      }
    ]
  },
  {
    step: "Step 5",
    title: "나만의 든든한 버디",
    subtitle: "안전과 프로의 상징, 다이빙 컴퓨터",
    description: "기본적인 현재 수심, 수온, 다이빙 시간 및 수면 휴식 시간 체크는 물론, 중성부력/프리폴/목표 수심 알람을 설정해 체계적인 하강을 돕습니다. 다이빙 직후 스마트폰으로 로그가 자동 기록되어 수심, 수온, 심박수 그래프를 보며 내 다이빙을 상세히 분석할 수 있는 최고의 파트너입니다.",
    isComputer: true,
    items: []
  },
  {
    step: "Step 6",
    title: "수심을 향한 도전",
    subtitle: "딥 다이버를 위한 전문 장비",
    description: "본격적인 수심 트레이닝을 시작하는 당신을 위한 하드코어 장비들. 이 장비들을 꺼내는 순간 당신은 이미 훌륭한 딥 다이버입니다.",
    items: [
      { 
        id: 'evolve', 
        name: "수심용 고글", 
        type: "advanced", 
        desc: "깊은 수심에서 발생하는 마스크 압착의 한계를 넘기 위한 유체역학적 전문가용 고글. 시야 왜곡이 없고 압착이 오지 않아 새로운 한계 수심으로 당신을 안내합니다.",
        products: [
          {
            badge: "클리어",
            badgeColor: "#64748b",
            name: "이볼브 프리큐 고글 V2",
            image: "https://freedivingstore.co.kr/web/product/big/202510/b726e1f03ea6a680e74d6af81739b989.jpg",
            link: "https://freedivingstore.co.kr/product/detail.html?product_no=2463&cate_no=27&display_group=1"
          },
          {
            badge: "틴트",
            badgeColor: "#64748b",
            name: "이볼브 프리큐 고글 V2 틴트",
            image: "https://freedivingstore.co.kr/web/product/big/202511/1ccdbefca7efcf3290a1dcdfb85f2244.jpg",
            link: "https://freedivingstore.co.kr/product/detail.html?product_no=2816&cate_no=27&display_group=1"
          }
        ]
      },
      { 
        id: 'noseclip', 
        name: "노즈클립", 
        type: "advanced", 
        desc: "손을 쓰지 않는 핸즈프리 이퀄라이징을 위한 궁극의 장비. 손의 제약에서 벗어나 가장 유선형의 자세로 하강해보세요.",
        products: [
          {
            badge: "알루미늄",
            badgeColor: "#64748b",
            name: "옥토퍼스 알루미늄 노즈클립",
            image: "https://www.pongdang.com/data/goods/1/2025/08/54172_temp_17555002942199view.jpg",
            link: "https://www.pongdang.com/goods/view?no=54172"
          },
          {
            badge: "컴팩트",
            badgeColor: "#ef4444",
            name: "랍스터 노즈클립",
            image: "https://www.pongdang.com/data/goods/1/2026/06/57491_temp_17805585098653view.png",
            link: "https://www.pongdang.com/goods/view?no=57491"
          }
        ]
      },
      { 
        id: 'lanyard', 
        name: "랜야드", 
        type: "advanced", 
        desc: "바다 한가운데서 가이드라인과 나를 연결해주는 든든한 생명줄. 수심 다이빙 시 없어서는 안 될 가장 중요한 안전 장비입니다.",
        products: [
          {
            badge: "옥토퍼스",
            badgeColor: "#64748b",
            name: "옥토퍼스 랜야드",
            image: "https://freedivingstore.co.kr/web/product/big/202212/958d2dc7d880107dc54ffeaa87ae2787.jpg",
            link: "https://freedivingstore.co.kr/product/detail.html?product_no=1143&cate_no=92&display_group=1"
          },
          {
            badge: "FreeXperience",
            badgeColor: "#64748b",
            name: "FreeXperience 랜야드",
            image: "https://freedivingstore.co.kr/web/product/big/202502/bd264534c640d7dacf2ef46d13bb1d69.jpg",
            link: "https://freedivingstore.co.kr/product/detail.html?product_no=647&cate_no=92&display_group=1"
          }
        ]
      }
    ]
  },
  {
    step: "Step 7",
    title: "나만의 수중 화보, 어떻게 남길까?",
    subtitle: "모든 다이버들의 로망, 하이엔드 수중 액션캠",
    description: "인생샷을 넘어 인생 '영상'을 남길 시간입니다. 어떤 구도든 360도로 완벽하게 담아내는 마법 같은 카메라와, 빛이 부족한 수심 깊은 곳에서도 숨 막히게 선명한 색감을 뽑아내는 플래그십 액션캠 중 당신의 스타일은 무엇인가요?",
    items: [
      { 
        id: 'camera360', 
        name: "360도 액션캠", 
        type: "advanced", 
        desc: "물속에서 카메라 앵글 맞추느라 고생할 필요가 없습니다. 차세대 듀얼 1/1.1인치 소니 센서가 압도적인 8K 화질로 모든 방향을 알아서 담아내니까요. 영상에서 마법처럼 사라지는 '투명 셀카봉' 효과 덕분에 마치 전담 수중 촬영 감독이 따라다니며 찍어준 듯한 드라마틱한 3인칭 뷰를 혼자서도 쉽게 완성할 수 있습니다. 수심 20m 자체 방수까지 지원하는 다이빙 영상의 완벽한 치트키입니다.",
        products: [
          {
            badge: "360도",
            badgeColor: "#64748b",
            name: "인스타360 X6",
            image: "https://wassets.insta360.com/store/60cb9f551aff4f158ef92ce0ca2c9a05/X6.png?x-oss-process=image%2Fauto-orient%2C1%2Fformat%2Cwebp%2Fquality%2Cq_90",
            link: "https://www.insta360.com/sal/x6?utm_source=AffiliateCenter&utm_medium=copylink&utm_term=INRZOZE"
          }
        ]
      },
      { 
        id: 'actioncam', 
        name: "플래그십 8K 액션캠", 
        type: "advanced", 
        desc: "어두운 바닷속에서도 타협 없는 최고의 화질을 원한다면 정답은 정해져 있습니다. 전설적인 라이카(Leica) 렌즈와 프리미엄 1/1.3인치 8K 센서, 그리고 듀얼 AI 칩의 결합이 수중 노이즈를 완벽하게 억제하고 눈부시게 쨍한 색감을 구현해냅니다. 물속에서도 내 모습을 보며 촬영할 수 있는 2.5인치 플립형 스크린까지 장착되어, 압도적인 결과물을 원하는 다이버들에게 가장 사랑받는 하이엔드 장비입니다.",
        products: [
          {
            badge: "액션캠",
            badgeColor: "#64748b",
            name: "인스타360 Ace Pro 2",
            image: "https://res.insta360.com/static/6f706c068778e64a636f62249bc2749e/PC.png?x-oss-process=image%2Fauto-orient%2C1%2Fformat%2Cwebp%2Fquality%2Cq_90",
            link: "https://www.insta360.com/sal/ace-pro-2?utm_source=AffiliateCenter&utm_medium=copylink&utm_term=INRZOZE"
          }
        ]
      }
    ]
  }
];

export const FINS_COMPARISON = {
  fiberglass: {
    title: "유리섬유 롱핀 (입문/중급용)",
    pros: ["플라스틱 핀보다 월등히 뛰어난 추진력", "상대적으로 합리적인 가격대", "햇빛을 받으면 아름답게 빛나는 투명한 재질의 컬러풀함"],
    cons: ["카본에 비해 약간 무겁고 뻣뻣함", "탄성(반발력)이 카본보다는 다소 떨어짐"],
    appeal: "초보 티를 벗고 플라스틱 핀의 한계를 넘고 싶다면! 물속에서 영롱하게 빛나는 인생샷을 원한다면 훌륭한 가성비의 선택입니다.",
    products: [
      {
        badge: "여성전용",
        badgeColor: "#ec4899",
        name: "디플리 새론 유리섬유 핀",
        image: "https://deeplyfin.com/web/product/medium/202602/a88a95d7d738483c7ffb97f529e5c228.jpg",
        link: "https://deeplyfin.com/category/%EC%83%88%EB%A1%A0/226/"
      },
      {
        badge: "유리섬유",
        badgeColor: "#0ea5e9",
        name: "디플리 미스티 유리섬유 핀",
        image: "https://deeplyfin.com/web/product/medium/202606/1c1a34f97b82c20e277fa30c3b343bc8.jpg",
        link: "https://deeplyfin.com/category/%EB%AF%B8%EC%8A%A4%ED%8B%B0/209/"
      },
      {
        badge: "유리섬유",
        badgeColor: "#0ea5e9",
        name: "더블케이 화이트팁 클래식 롱핀",
        image: "https://divingkk.com/web/product/big/202604/123d7441b9c99d466c8732ebdaabac9b.jpg",
        link: "https://divingkk.com/product/detail.html?product_no=2610&cate_no=417&display_group=1"
      },
      {
        badge: "유리섬유",
        badgeColor: "#0ea5e9",
        name: "오션태그 스완 롱핀",
        image: "https://godomall-storage.cdn-nhncommerce.com/f49b02212eea007a8cefdaf6997a1fdd/goods/1766/image/detail/1766_detail_071.jpg",
        link: "https://www.oceantag.com/goods/goods_view.php?goodsNo=1766"
      }
    ]
  },
  carbon: {
    title: "퓨어 카본 롱핀 (하이엔드/고수용)",
    pros: ["깃털처럼 가벼운 무게로 발목 무리 최소화", "가볍게 차도 폭발적으로 튀어나가는 압도적인 추진력", "블랙 카본 패턴 특유의 시크하고 독보적인 고급스러움"],
    cons: ["높은 가격대 (장비 중 가장 비싼 편)", "충격에 깨질 수 있어 관리에 주의 필요"],
    appeal: "다이빙 풀에서 시선을 한 몸에 받는 압도적인 아우라. 결국 언젠가는 카본으로 가게 됩니다. 한 번에 끝판왕으로 가서 중복 투자를 막는 것이 진짜 현명한 선택!",
    products: [
      {
        badge: "퓨어카본",
        badgeColor: "#1e293b",
        name: "알케미 V3-30 (마레스 X-wing)",
        image: "https://freedivingstore.co.kr/web/product/big/202312/3c670a78a00344c702b318c13f7c869f.jpg",
        link: "https://freedivingstore.co.kr/product/detail.html?product_no=2376&cate_no=43&display_group=1"
      },
      {
        badge: "퓨어카본",
        badgeColor: "#1e293b",
        name: "알케미 오로라 V3-30 (마레스 X-wing)",
        image: "https://freedivingstore.co.kr/web/product/big/202502/b0790cf2c71ce1c41c9eb0c613a49668.jpg",
        link: "https://freedivingstore.co.kr/product/detail.html?product_no=2473&cate_no=43&display_group=1"
      }
    ]
  }
};

export const COMPUTER_COMPARISON = {
  mk3i: {
    title: "가민 디센트 Mk3i 51mm (플래그십/전문가용)",
    pros: ["아몰레드 디스플레이의 쨍하고 압도적인 시인성", "티타늄 베젤과 사파이어 크리스탈 렌즈의 완벽한 내구성", "수중에서 심박수까지 정밀하게 측정하는 최첨단 센서"],
    cons: ["매우 높은 가격대 (끝판왕 프리미엄)", "51mm의 큰 사이즈로 손목이 얇다면 다소 부담스러울 수 있음"],
    appeal: "비용에 구애받지 않고 현존하는 최고의 다이빙 컴퓨터를 원한다면 단연 Mk3i입니다. 일상에서도 압도적인 존재감을 뿜어냅니다.",
    products: [
      {
        badge: "Mk3i",
        badgeColor: "#1e293b",
        name: "가민 디센트 Mk3i 51mm",
        image: "https://www.pongdang.com/data/goods/1/2024/01/54365_temp_17055560657874view.jpg",
        link: "https://www.pongdang.com/goods/view?no=54365"
      }
    ]
  },
  g2: {
    title: "가민 디센트 G2 45.5mm (엔트리/가성비)",
    pros: ["스마트워치에 가까운 비교적 합리적인 가격대", "45.5mm의 부담 없는 사이즈와 가볍고 편안한 착용감", "중성부력, 목표 수심 알람 등 프리다이빙 필수 기능 완벽 지원"],
    cons: ["플라스틱(레진) 베젤 소재로 인한 약간 캐주얼한 느낌", "디스플레이 화질과 선명도가 Mk3i에 비해서는 다소 떨어짐"],
    appeal: "가민 특유의 정확한 수심 알람과 로그 앱 자동 연동의 편리함을 누리고 싶지만, 가격이 부담스럽다면 최고의 선택입니다.",
    products: [
      {
        badge: "G2",
        badgeColor: "#1e293b",
        name: "가민 디센트 G2 45.5mm",
        image: "https://www.pongdang.com/data/goods/1/2026/06/58189_temp_17809890680775view.png",
        link: "https://www.pongdang.com/goods/view?no=58189"
      }
    ]
  }
};

export const WETSUIT_COMPARISON = {
  pool: {
    title: "풀장용 (0.5~2mm 글라이드)",
    pros: ["물 저항을 최소화하는 매끄러운 글라이드스킨 소재", "2mm 이하의 얇은 두께로 최상의 활동성 제공", "실내 다이빙 풀장의 따뜻한 수온에 최적화"],
    cons: ["외부 스크래치에 매우 취약함 (손톱 주의)", "야외 바다(동해 등)에서 입기에는 보온성이 부족함"],
    appeal: "수영장 트레이닝을 주로 하거나 가벼운 열대 바다 펀다이빙을 즐긴다면 가장 완벽한 퍼포문을 내는 슈트입니다.",
    products: [
      {
        badge: "글라이드스킨",
        badgeColor: "#64748b",
        name: "다이브앤세일 클래식 투피스 (남성용)",
        image: "https://divesl.co.kr/data/goods/1/2025/10/117_temp_17619173994887view.jpg",
        link: "https://divesl.co.kr/goods/view?no=117"
      },
      {
        badge: "1.2mm",
        badgeColor: "#64748b",
        name: "트루다이브 Future Warrior Series",
        image: "https://shop-phinf.pstatic.net/20250715_208/1752566535598lt3ik_JPEG/65663444600886585_401494223.jpg?type=o1000",
        link: "https://smartstore.naver.com/freeweeny/products/12106882181"
      },
      {
        badge: "후드 투피스",
        badgeColor: "#64748b",
        name: "시어친 언터쳐블 후드 투피스",
        image: "https://seaurchin.kr/web/product/big/202603/d7cd0542141199e40b49e66ffdecbc34.jpg",
        link: "https://seaurchin.kr/product/detail.html?product_no=60&cate_no=42&display_group=1"
      }
    ]
  },
  spring: {
    title: "여성용 스프링슈트",
    pros: ["다리가 노출되어 수중에서 다리가 길어보이는 완벽한 핏", "입고 벗기가 원피스처럼 매우 간편함", "비키니 컷 등 다양한 디자인 선택지"],
    cons: ["하체 보온성이 떨어져 차가운 물에서는 다이빙 타임이 짧아짐", "해파리나 산호로부터 다리를 보호할 수 없음"],
    appeal: "따뜻한 휴양지 바다나 수온이 높은 풀장에서 인생 수중샷을 남기고 싶은 여성 다이버들의 영원한 워너비 아이템입니다.",
    products: [
      {
        badge: "비키니컷",
        badgeColor: "#ec4899",
        name: "TRUDIVE 만타 Starry Bikini Wetsuit",
        image: "https://shop-phinf.pstatic.net/20250624_7/1750727472270C3iHt_JPEG/84860273013061186_2090711811.jpg?type=o1000",
        link: "https://smartstore.naver.com/freeweeny/products/11754339280"
      },
      {
        badge: "집업 비키니",
        badgeColor: "#ec4899",
        name: "TRUDIVE 아기고래 집업 비키니 2mm",
        image: "https://shop-phinf.pstatic.net/20240728_150/1722128083147s2gIV_JPEG/2130309529658674_1992693264.jpg?type=o1000",
        link: "https://smartstore.naver.com/freeweeny/products/9828136135"
      },
      {
        badge: "하이컷",
        badgeColor: "#ec4899",
        name: "시어친 홀터넥 모노키니",
        image: "https://seaurchin.kr/web/product/big/202603/ad8ff5ff043f61acadc64f36bde38ce3.png",
        link: "https://seaurchin.kr/product/detail.html?product_no=48&cate_no=42&display_group=1"
      },
      {
        badge: "홀터넥",
        badgeColor: "#ec4899",
        name: "다이브앤세일 슬리브리스 홀터넥 스프링슈트",
        image: "https://divesl.co.kr/data/goods/1/2025/10/58_temp_17615673306631view.jpg",
        link: "https://divesl.co.kr/goods/view?no=58"
      }
    ]
  },
  ocean: {
    title: "동해/야외용 (3~5mm 오픈셀)",
    pros: ["피부에 찰싹 달라붙는 오픈셀 안감으로 극강의 보온성 유지", "3~5mm 두께로 차가운 동해 바다도 커버 가능", "바위나 부유물로부터 전신을 안전하게 보호"],
    cons: ["내부가 고무(오픈셀)라 입을 때 샴푸물이나 윤활제가 필수", "두꺼워서 부력이 강해 웨이트 납을 많이 차야 함"],
    appeal: "우리나라 바다(동해, 제주 등)를 본격적으로 탐험하고 싶은 다이버라면 선택이 아닌 필수 생존 장비입니다.",
    products: [
      {
        badge: "남성용",
        badgeColor: "#3b82f6",
        name: "다이브앤세일 오픈셀슈트 (남성용)",
        image: "https://divesl.co.kr/data/goods/1/2025/10/38_temp_17615597695939view.jpg",
        link: "https://divesl.co.kr/goods/view?no=38"
      },
      {
        badge: "여성용",
        badgeColor: "#3b82f6",
        name: "다이브앤세일 오픈셀슈트 (여성용)",
        image: "https://divesl.co.kr/data/goods/1/2025/10/40_temp_17615468689580view.jpg",
        link: "https://divesl.co.kr/goods/view?no=40"
      },
      {
        badge: "카오스",
        badgeColor: "#3b82f6",
        name: "압네아 Xaos 3mm / 5mm 프리다이빙 슈트",
        image: "https://www.pongdang.com/data/goods/310/2022/06/_temp_16565773897380view.png",
        link: "https://www.pongdang.com/goods/view?no=50144"
      }
    ]
  }
};
